export default "__VITE_ASSET__DpqyRmpA__"